const appConfig = {    
    urlForDotCom: '',
    logoutUrls: {
      QualificationWorkspace: '',
      QualificationWorkspaceAdmin: '',
      DotCom: '',
      Apps: '',
      Voting: '',
      Zendesk: '',
      MSCpy: ''
    },
    logglyTags: window.location.host.split('.')[1],
    logglyToken: '1c7834ca-3f1e-48fa-9b21-e5f5a14af1da',
    logglySubDomain: 'bluetoothsig.com',
    urlForAppSettings: '',
    urlForWelcomeHub: '',
    clientId: '',
    redirect_uri: '',
    audience: '',
    auth0:
    {
      "domain": '',
      "clientId": '',
      "authorizationParams": {
        "redirect_uri": '',
        "audience": ''
      }
    }
  }
  
  switch (window.location.host) {        
    case 'localhost:8080':
      appConfig.urlForDotCom = 'https://www.bttest.net'
      appConfig.logoutUrls = {
        QualificationWorkspace: 'https://qualification.bttest.net/Account/Logout',
        QualificationWorkspaceAdmin: 'https://qualificationadmin.bttest.net/Account/Logout',
        DotCom: 'https://www.bttest.net/api/silentlogin/logout',
        Apps: 'https://apps.bttest.net/login/logout',
        Voting: 'https://voting.bttest.net/logout',
        Zendesk: 'https://support.bluetooth.com/access/logout?return_to=https%3A%2F%2Fsupport.bluetooth.com%2Fhc%2Fen-us',
        MSCpy: 'https://msc-generator.bttest.net/Account/Logout'
      }
      appConfig.urlForAppSettings = 'https://apps.bttest.net/mysettings#/'
      appConfig.urlForWelcomeHub = 'https://welcome.bttest.net'
      appConfig.auth0 =
      {
        "domain": "btpoc.us.auth0.com",
        "clientId": "dZgG7ndj038zrhb7aJwVhYvETB0dJjA0",
        "authorizationParams": {
          "redirect_uri": "http://localhost:8080/callback",
          "audience": "https://btpoc.us.auth0.com/api/v2/"
        }
      }
      break
    case 'login.bttest.net': 
      appConfig.urlForDotCom = 'https://www.bttest.net'
      appConfig.logoutUrls = {
        QualificationWorkspace: 'https://qualification.bttest.net/Account/Logout',
        QualificationWorkspaceAdmin: 'https://qualificationadmin.bttest.net/Account/Logout',
        DotCom: 'https://www.bttest.net/api/silentlogin/logout',
        Apps: 'https://apps.bttest.net/login/logout',
        Voting: 'https://voting.bttest.net/logout',
        Zendesk: 'https://support.bluetooth.com/access/logout?return_to=https%3A%2F%2Fsupport.bluetooth.com%2Fhc%2Fen-us',
        MSCpy: 'https://msc-generator.bttest.net/Account/Logout'
      }
      appConfig.urlForAppSettings = 'https://apps.bttest.net/mysettings#/'
      appConfig.urlForWelcomeHub = 'https://welcome.bttest.net'
      appConfig.auth0 =
      {
        "domain": 'auth.bttest.net',
        "clientId": 'ZCxOO2AtcaQq7Y37lNPcmv4pRTzrEyH5',
        "authorizationParams": {
          "redirect_uri": 'https://login.bttest.net/callback',
          "audience": 'https://bttestnet.auth0.com/api/v2/'
        }
      }      
      break
    case 'login.btstage.net':
      appConfig.urlForDotCom = 'https://www.btstage.net'
      appConfig.logoutUrls = {
        QualificationWorkspace: 'https://qualification.btstage.net/Account/Logout',
        QualificationWorkspaceAdmin: 'https://qualificationadmin.btstage.net/Account/Logout',
        DotCom: 'https://www.btstage.net/api/silentlogin/logout',
        Apps: 'https://apps.btstage.net/login/logout',
        Voting: 'https://voting.btstage.net/logout',
        Zendesk: 'https://support.bluetooth.com/access/logout?return_to=https%3A%2F%2Fsupport.bluetooth.com%2Fhc%2Fen-us',
        MSCpy: 'https://msc-generator.btstage.net/Account/Logout'
      }
      appConfig.urlForAppSettings = 'https://apps.btstage.net/mysettings#/'
      appConfig.urlForWelcomeHub = 'https://welcome.btstage.net'
      appConfig.auth0 =
      {
        "domain": 'auth.btstage.net',
        "clientId": 'Ms4LyCqaJEJD1B4bQbCIei8d4ASe3Lkr',
        "authorizationParams": {
          "redirect_uri": 'https://login.btstage.net/callback',
          "audience": 'https://btstagenet.auth0.com/api/v2/'
        }
      }
      break
    case 'login.btharald.net':      
      appConfig.urlForDotCom = 'https://www.btharald.net'
      appConfig.logoutUrls = {
        QualificationWorkspace: 'https://qualification.btharald.net/Account/Logout',
        QualificationWorkspaceAdmin: 'https://qualificationadmin.btharald.net/Account/Logout',
        DotCom: 'https://www.btharald.net/api/silentlogin/logout',
        Apps: 'https://apps.btharald.net/login/logout',
        Voting: 'https://voting.btharald.net/logout',
        Zendesk: 'https://support.bluetooth.com/access/logout?return_to=https%3A%2F%2Fsupport.bluetooth.com%2Fhc%2Fen-us',
        MSCpy: 'https://msc-generator.btharald.net/Account/Logout'
      }
      appConfig.urlForAppSettings = 'https://apps.btharald.net/mysettings#/'
      appConfig.urlForWelcomeHub = 'https://welcome.btharald.net'
      appConfig.auth0 =
      {
        "domain": 'auth.btharald.net',
        "clientId": 'xR7zuXRa6m3wEoG3Lbt6lc69mUIlyqwR',
        "authorizationParams": {
          "redirect_uri": 'https://login.btharald.net/callback',
          "audience": 'https://btharaldnet.auth0.com/api/v2/'
        }
      }
      break
    case 'login.bluetooth.com':      
      appConfig.urlForDotCom = 'https://www.bluetooth.com'
      appConfig.logglyTags = 'btprod ' + 'login'
      appConfig.logoutUrls = {
        QualificationWorkspace: 'https://qualification.bluetooth.com/Account/Logout',
        QualificationWorkspaceAdmin: 'https://qualificationadmin.bluetooth.com/Account/Logout',
        DotCom: 'https://www.bluetooth.com/api/silentlogin/logout',
        Apps: 'https://apps.bluetooth.com/login/logout',
        Voting: 'https://voting.bluetooth.com/logout',
        Zendesk: 'https://support.bluetooth.com/access/logout?return_to=https%3A%2F%2Fsupport.bluetooth.com%2Fhc%2Fen-us',
        MSCpy: 'https://msc-generator.bluetooth.com/Account/Logout'
      }
      appConfig.urlForAppSettings = 'https://apps.bluetooth.com/mysettings#/'
      appConfig.urlForWelcomeHub = 'https://welcome.bluetooth.com'
      appConfig.auth0 =
      {
        "domain": 'authaz.bluetooth.com',
        "clientId": 'H0bSrzZeybn5HodDAXdeG1RTWw58K4Hp',
        "authorizationParams": {
          "redirect_uri": 'https://login.bluetooth.com/callback',
          "audience": 'https://btcom.auth0.com/api/v2/'
        }
      }     
      break
    default:
      break
  }
  
  export default appConfig
  